export default __webpack_public_path__ + "static/media/67.9e105dca.png";